import { fetchJSON } from 'js-utils/http';

// Default page_size of search from search_service, we need
// to make sure we expand on the same number
const DEFAULT_SEARCH_PAGE_SIZE = 20;

const DEFAULT_EXPANSIONS =
    'series,event_sales_status,primary_venue,image,saves,my_collections,ticket_availability';

const DESTINATION_EVENTS_ENDPOINT = '/api/v3/destination/events/';

export const fetchEventExpansions = (eventIds = []) => {
    const eventIdsJoined = eventIds.join(',');

    return fetchJSON(
        `${DESTINATION_EVENTS_ENDPOINT}?event_ids=${eventIdsJoined}&expand=${DEFAULT_EXPANSIONS}&page_size=${DEFAULT_SEARCH_PAGE_SIZE}`,
    );
};
